var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrolling-message-container"},[_c('div',{staticClass:"scrolling-message"},[_c('span',{staticClass:"msg"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }